import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1300Model } from '../kymw1300.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * 商品企画マスタ画面　企画ロック解除するサービス
 *
 * @export DeleteLockInfoCatalogService
 * @class DeleteLockInfoCatalogService
 * @extends {PlessJsonResponderSub<any>}
 */
@Injectable()
export class DeleteLockInfoCatalogService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof DeleteLockInfoCatalogService
   */
  private model: KYMW1300Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof DeleteLockInfoCatalogService
   */
  private vo: {
    orderCode: '',
    mediumType: '',
  };

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof DeleteLockInfoCatalogService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteLockInfoCatalogService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      delete: {
        DeleteLockInfoCatalog: {
          condition: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   * TODO これはどこからもよびだされていないのでは？
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof DeleteLockInfoCatalogService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1300Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('deleteLockInfoCatalog', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteLockInfoCatalogService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
